//components
import { VideoPlayer } from '@/containers-m/VideoPlayer';

//styles
import {
  VideoHeroWrapper,
  ContainerStyled,
  MediaWrapper,
} from './VideoHero.styles';

const video_settings = {
  youtube: 'https://www.youtube.com/watch?v=Xlf9Umf3jC4?rel=0',
  thumb: '/images/managed-transportation/mg_video-thumb.webp',
  preview: '/videos/managed-transportation/bg_managedtrans.webm',
};

export function VideoHero() {
  return (
    <VideoHeroWrapper>
      <ContainerStyled>
        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>
      </ContainerStyled>
    </VideoHeroWrapper>
  );
}
